import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=3234b02f&scoped=true&"
import script from "./VideoCall.vue?vue&type=script&lang=js&"
export * from "./VideoCall.vue?vue&type=script&lang=js&"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=3234b02f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3234b02f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3234b02f')) {
      api.createRecord('3234b02f', component.options)
    } else {
      api.reload('3234b02f', component.options)
    }
    module.hot.accept("./VideoCall.vue?vue&type=template&id=3234b02f&scoped=true&", function () {
      api.rerender('3234b02f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VideoCall.vue"
export default component.exports